import * as types from './_actionTypes';

const initialState = {
  smes: [],
  loading: false,
  createLoading: false,
  actionLoading: {},
  error: null
};

const adminSMEReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SMES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.FETCH_SMES_SUCCESS:
      return {
        ...state,
        loading: false,
        smes: action.payload,
        error: null
      };

    case types.FETCH_SMES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case types.CREATE_SME_REQUEST:
      return {
        ...state,
        createLoading: true,
        error: null
      };

    case types.CREATE_SME_SUCCESS:
      return {
        ...state,
        createLoading: false,
        smes: [...state.smes, action.payload],
        error: null
      };

    case types.CREATE_SME_FAILURE:
      return {
        ...state,
        createLoading: false,
        error: action.payload
      };

    case types.DELETE_SME_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: true
        }
      };

    case types.DELETE_SME_SUCCESS:
      return {
        ...state,
        smes: state.smes.filter(sme => sme.id !== action.payload),
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        }
      };

    case types.DELETE_SME_FAILURE:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload.smeId]: false
        },
        error: action.payload.error
      };

    case types.UPDATE_SME_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.UPDATE_SME_SUCCESS:
      return {
        ...state,
        loading: false,
        smes: state.smes.map(sme =>
          sme.id === action.payload.id ? action.payload : sme
        ),
        error: null
      };

    case types.UPDATE_SME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default adminSMEReducer;